export const enum HiddenPostType {
  Visible = 0,
  TemporarilyHidden = 1,
  Hidden = 2,
}
